import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Button, Stack, Typography} from '@mui/material';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import genericErrorImg from 'presentation/assets/images/lifestyle-meditation.svg';
import {HomeEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages';
import {StyledBox, StyledCard, StyledStack} from './styles';
import {ProductLogo} from '../ProductLogo';
import {ErrorFallbackProps} from './types';

const {tryAgain, backToHome} = translations['pt-br'].commons;
const {title, description} = translations['pt-br'].others.fallbackError;

export function ErrorFallback({resetErrorBoundary}: ErrorFallbackProps) {
	const {isMobile, isTablet} = useMediaQueries();
	const navigate = useNavigate();

	function handleGoBackToHome() {
		navigate(HomeEnum.HOME_PAGE);
		resetErrorBoundary();
	}

	function handleTryAgain() {
		window.location.reload();
	}

	return (
		<StyledStack>
			<StyledBox>
				<img src={genericErrorImg} alt={title} />
			</StyledBox>
			<StyledCard elevation={0}>
				<ProductLogo />
				<Stack gap={isMobile ? 1 : 2}>
					<Typography textAlign={isTablet ? 'center' : 'start'} variant="h5">
						{title}
					</Typography>
					<Typography
						variant={isMobile ? 'body2' : 'body1'}
						textAlign={isTablet ? 'center' : 'start'}
						color="text.secondary">
						{description}
					</Typography>
				</Stack>
				<Stack gap={1.5} width="100%">
					<Button
						onClick={handleGoBackToHome}
						startIcon={<Icon name="arrow-left-filled" />}>
						{backToHome}
					</Button>
					<Button
						variant="outlined"
						onClick={handleTryAgain}
						startIcon={<Icon name="reload" />}>
						{tryAgain}
					</Button>
				</Stack>
			</StyledCard>
		</StyledStack>
	);
}
